import React from 'react';
import { DividerWrapper } from './styles';

export const Divider: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = props => {
  return <DividerWrapper {...props}></DividerWrapper>;
};
